import { BaseApi } from './base.api.js';

export class RegulatoryClauseApi extends BaseApi {
    constructor(client) {
        super(client, '/regulatory-clause');
    }
}
